import React from 'react';
import styled from 'styled-components';
import { FaUtensils, FaWifi, FaParking, FaBell } from 'react-icons/fa';

// Styled Components
const ServicesSection = styled.section`
  padding: 5rem 0;
  background-color: #f8fafc;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: #f59e0b;
  }
`;

const ServicesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const ServiceCard = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  }
`;

const IconWrapper = styled.div`
  font-size: 2.5rem;
  color: #1e3a8a;
  margin-bottom: 1.5rem;
  
  svg {
    filter: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07));
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
  color: #1f2937;
`;

const ServiceDescription = styled.p`
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.6;
`;

// Service data
const services = [
  {
    id: 1,
    icon: <FaUtensils />,
    title: 'Fine Dining',
    description: 'Multi-cuisine restaurant with lakefront dining area'
  },
  {
    id: 2,
    icon: <FaWifi />,
    title: 'Free Wi-Fi',
    description: 'High-speed internet access throughout the property'
  },
  {
    id: 3,
    icon: <FaParking />,
    title: 'Ample Parking',
    description: 'Spacious car parking with 24/7 security'
  },
  {
    id: 4,
    icon: <FaBell />,
    title: '24/7 Room Service',
    description: 'Round-the-clock assistance for all your needs'
  }
];

const Services = () => {
  return (
    <ServicesSection id="services">
      <SectionTitle>Our Services</SectionTitle>
      <ServicesContainer>
        {services.map((service) => (
          <ServiceCard key={service.id}>
            <IconWrapper>{service.icon}</IconWrapper>
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
          </ServiceCard>
        ))}
      </ServicesContainer>
    </ServicesSection>
  );
};

export default Services;
